import CaptureBagHero from "../../assets/products/capture-bag/cb-deploy-iss.gif";
import CaptureBag2 from "../../assets/capabilities/capture/capture-2.png";

import React from "react";

export const captureBagData = {
  title: "Capture Bag",
  cardsPosition: "bottom",
  heroCards: [
    {
      title: "Revolutionary Capture Technology",
      description: "Advanced bag capture system designed for space applications with unmatched reliability and efficiency",
    },
    {
      title: "Versatile Applications",
      description: "From debris removal to asteroid capture, our capture bag technology adapts to various mission requirements",
    },
    {
      title: "Space-Proven Design",
      description: "Engineered for the harsh environment of space with rigorous testing and validation",
    },
  ],
  content: [
    {
      href: CaptureBagHero,
    },
    {
      title: "Advanced Capture Capabilities",
      cardsPosition: "bottom",
      cards: [
        {
          title: "Innovative Design",
          description: "Our capture bag features a unique design that enables secure capture of objects in space with minimal risk of damage",
        },
        {
          title: "Mission Flexibility",
          description: "Adaptable to various mission profiles including asteroid capture, debris removal, and satellite servicing",
        },
        {
          title: "Reliable Operation",
          description: "Designed for reliable deployment and capture operations in the challenging space environment",
        },
      ],
      href: CaptureBag2,
    },
  ],
};
